// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import Router from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import http from './http'
import store from './vuex/store'
import App from './App'
import './assets/css/global.scss'
//
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VueClipboard from 'vue-clipboard2'
import echarts from 'echarts'
// 引入全局方法（变更管理）
import getChanges from './plugin/getChages' // 引入
// 全局引入视频插件
import VideoPlayer from 'vue-video-player'
import showFile from '@/components/showFile/showFile.js'
import './permission'
import selectCompany from '@/components/selectCompany/selectCompany.js'
import selectCheckList from '@/components/selectCheckList/selectCheckList.js'
import Directives from '@/directives/index'
// 调用公共方法
import common from './common'
import selectExpert from '@/components/selectExpert/selectExpert'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

//电子签名
import vueEsign from 'vue-esign'

Vue.use(selectExpert)
Vue.use(Directives)
Vue.use(VideoPlayer)
Vue.use(selectCompany)
Vue.use(selectCheckList)
Vue.use(showFile)
Vue.use(getChanges)
Vue.use(VueClipboard)
Vue.use(VueQuillEditor)
Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.use(ElementUI)
Vue.use(common)
Vue.prototype.$echarts = echarts
Vue.use(vueEsign)

// 当进入相同路径的路由时会报错，该代码修复此bug
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js